import { BaseEntity } from "./BaseEntity";

export class PermissionManagementEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.settings.permissionManagementList.permissionManagement";
        this.pageTitle = "components.settings.permissionManagement.menuList.Permission Management";
        this.menuPath = "/settings";
        this.APIRoute = "Resources/Settings/Permission Management"
        this.i18nBase = "components.settings.permissionManagement";
        this.baseEndPoint = "workgroup";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`
        };

        this.fieldsStep1 = [
            {
                key: "id",
                label: "user.fields.id",
                type: "hidden",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "name",
                label: "components.settings.permissionManagement.groupName",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 12,
                path: "name"
            },
            {
                key: "corp_id",
                label: "Corporação",
                type: "autocomplete",
                visible: true,
                required: true,
                editable: true,
                readOnly: true,
                cols: 6,
                source: "corpList",
                searchHandler: "handleCorpList",
                options: [],
                path: "corp_id"
            },
            {
                key: "permissions",
                label: "Menu",
                type: "Treeview",
                visible: true,
                required: true,
                editable: true,
                options: [],
                cols: 12,
                path: "permissions"
            },
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path:"status"
            },
        ]

        this.fieldsStep2 = [
            {
                key: "users",
                label: "components.settings.permissionManagement.usersEmail",
                type: "autocomplete",
                searchHandler: "handleSearchUsersToSave",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                multiple: true,
                path: "users"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "qtdUsers",
                label: "components.settings.permissionManagementList.linkedUsers",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path:"status"
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings/components.settings.permissionManagement.menuList.Permission Management`,
                route: ["/settings","/settings/permission-management", "/settings/permission-management/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings/components.settings.permissionManagement.menuList.Permission Management`,
                route: ["/settings","/settings/permission-management", "/settings/permission-management/create"]
            },
            list: {
                pageTitle: `components.settings.permissionManagement.menuList.Permission Management`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings`,
                route: ["/settings", "/settings/permission-management"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
